import React, { useId, useState } from 'react';
import { ChatLeftText } from 'react-bootstrap-icons';
import IconButton from '@mui/material/IconButton';
import Popover from '@mui/material/Popover';
import Tooltip from '@mui/material/Tooltip';
import { useTranslations } from '../context/TranslationsContext';

const NotesButton = ({ notes }) => {
    const { t } = useTranslations();
    const [anchorEl, setAnchorEl] = useState(null);
    const id = useId();
    const open = Boolean(anchorEl);

    return (
        <>
            <Tooltip title={open ? '' : notes} disableTouchListener arrow>
                <IconButton
                    className="notes-button"
                    aria-label={t('notes', 'Notes')}
                    aria-expanded={open}
                    aria-controls={open ? id : undefined}
                    onClick={(event) => setAnchorEl(event.currentTarget)}
                    sx={{
                        color: 'inherit',
                        fontSize: 'inherit',
                        width: 44,
                        height: 44,
                        '&& svg': { margin: 0, cursor: 'pointer' },
                    }}
                >
                    <ChatLeftText />
                </IconButton>
            </Tooltip>
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={() => setAnchorEl(null)}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                slotProps={{
                    paper: {
                        sx: {
                            maxWidth: 'min(360px, calc(100vw - 32px))',
                            padding: 2,
                            whiteSpace: 'pre-wrap',
                            overflowWrap: 'anywhere',
                        },
                    },
                }}
            >
                {notes}
            </Popover>
        </>
    );
};

export default NotesButton;
